import { toError } from "fp-ts/Either";
import { print } from "graphql";
import type {
  GetAllMaterialTypesQuery,
  GetAllMaterialTypesQueryVariables,
  GetAllProvenanceCategoriesQuery,
  GetAllProvenanceCategoriesQueryVariables,
  GetCountriesQuery,
  GetCountriesQueryVariables,
  GetManualAccessionNumberErrorsQuery,
  GetManualAccessionNumberErrorsQueryVariables,
} from "../../../generated/graphql";
import { noGQLVars } from "../../utils/empty";
import { authedFetcher } from "../../utils/gql-client";
import { createAuthedHook } from "../../utils/hooks/hook";
import { createWrappedSWRHook } from "../../utils/swr";
import {
  getCountriesDocument,
  getManualAccessionNumberErrorsDocument,
  getMaterialTypesDocument,
  getProvenanceCategoriesDocument,
} from "./graphql";

export const fetchMaterialTypes = authedFetcher<
  GetAllMaterialTypesQueryVariables,
  GetAllMaterialTypesQuery
>(print(getMaterialTypesDocument))("GetAllMaterialTypes", noGQLVars);

export const useMaterialTypes = createAuthedHook(
  createWrappedSWRHook(fetchMaterialTypes, toError),
);

export const fetchProvenanceCategories = authedFetcher<
  GetAllProvenanceCategoriesQueryVariables,
  GetAllProvenanceCategoriesQuery
>(print(getProvenanceCategoriesDocument))(
  "GetAllProvenanceCategories",
  noGQLVars,
);

export const useProvenanceCategories = createAuthedHook(
  createWrappedSWRHook(fetchProvenanceCategories, toError),
);

export const fetchCountries = authedFetcher<
  GetCountriesQueryVariables,
  GetCountriesQuery
>(print(getCountriesDocument))("GetCountries", noGQLVars);

export const useCountries = createAuthedHook(
  createWrappedSWRHook(fetchCountries, toError),
);

export const fetchManualAccessionNumberErrors = authedFetcher<
  GetManualAccessionNumberErrorsQueryVariables,
  GetManualAccessionNumberErrorsQuery
>(print(getManualAccessionNumberErrorsDocument))(
  "GetManualAccessionNumberErrors",
).fetch;
